/**
 * View script for the block.
 */

import Mmenu from 'mmenu-js';

const menu_id = '#mmenu';
const logo = document.querySelector('.wp-site-blocks > header .wp-block-site-logo');
const toggle = document.querySelector('.wp-block-visual4-mobile-menu__toggle');

document.addEventListener(
    "DOMContentLoaded", () => {

        const menu = new Mmenu(menu_id, {
                // options
                "offCanvas": {
                    "position": "right-front"
                },
                "theme": "light",
                "navbars": [
                    {
                        "position": "top",
                        "content": [
                            logo ? logo.cloneNode(true) : '',
                            "close"
                        ]
                    }
                ]
            },
            {
                // configuration
                "offCanvas": {
                    "page": {
                        "selector": ".wp-site-blocks"
                    }
                },
                "classNames": {
                    "selected": "active-menu-item"
                }
            }
        );

        const api = menu.API;

        // Open the menu when the toggle button is clicked
        toggle.addEventListener(
            "click", () => {
                api.open();
            }
        );

    }
);